import { editStore, imageStore } from '../stores';
import { get } from 'svelte/store';

// 편집 유틸리티 함수
// resultImage 인자는 백엔드에서 반환한 파일 경로 또는 기존 Base64 문자열일 수 있다.
export function addToHistory(feature, settings, resultImage, taskId = null, processId = null) {
  editStore.update(store => {
    // 현재 인덱스 이후의 기록은 삭제
    const newHistory = [...store.editHistory];
    
    // 캔버스 데이터 가져오기
    let canvasData = null;
    let originalImage = null;
    
    const imgStore = get(imageStore);
    canvasData = imgStore.canvasData;
    originalImage = imgStore.uploadedImageUrl; // 원본 이미지 URL 저장
    
    // 현재 작업 ID 결정 (매개변수 우선)
    const currentTaskId = taskId || store.currentTaskId;
    
    // 새 편집 기록 추가 (작업 ID 포함)
    const newHistoryItem = {
      feature,
      settings: JSON.parse(JSON.stringify(settings)), // 깊은 복사로 객체 참조 문제 방지
      resultImage,
      canvasData,
      taskId: currentTaskId,
      processId, // 작업 ID를 기록에 포함시켜 나중에 필터링 가능하게 함
      originalImage, // 원본 이미지 URL도 저장하여 나중에 구별 가능하게 함
      timestamp: Date.now() // 타임스탬프 추가
    };
    
    newHistory.push(newHistoryItem);
    
    console.log(`편집 기록 추가됨: ${feature.name}, 작업 ID: ${currentTaskId}, 총 ${newHistory.length}개`);
    
    return {
      ...store,
      editHistory: newHistory,
      currentEditIndex: newHistory.length - 1
    };
  });
}

export function goToPreviousEdit() {
  editStore.update(store => {
    if (store.currentEditIndex > 0) {
      const newIndex = store.currentEditIndex - 1;
      const prevEdit = store.editHistory[newIndex];
      
      imageStore.update(imgStore => ({
        ...imgStore,
        resultImage: prevEdit.resultImage,
        resultFeature: prevEdit.feature?.id, resultOptions: prevEdit.settings, resultImages: null,
        canvasData: prevEdit.canvasData || null
      }));

      return {
        ...store,
        currentEditIndex: newIndex,
        selectedFeature: prevEdit.feature
      };
    }
    return store;
  });
}

export function goToNextEdit() {
  editStore.update(store => {
    if (store.currentEditIndex < store.editHistory.length - 1) {
      const newIndex = store.currentEditIndex + 1;
      const nextEdit = store.editHistory[newIndex];
      
      imageStore.update(imgStore => ({
        ...imgStore,
        resultImage: nextEdit.resultImage,
        resultFeature: nextEdit.feature?.id, resultOptions: nextEdit.settings, resultImages: null,
        canvasData: nextEdit.canvasData || null
      }));

      return {
        ...store,
        currentEditIndex: newIndex,
        selectedFeature: nextEdit.feature
      };
    }
    return store;
  });
}

export function goToHistoryItem(index) {
  editStore.update(store => {
    if (index === -1) {
      imageStore.update(imgStore => ({
        ...imgStore,
        resultImage: null,
        resultFeature: null, resultOptions: null, resultImages: null,
        canvasData: null
      }));

      return {
        ...store,
        currentEditIndex: -1,
        selectedFeature: null
      };
    } else if (index >= 0 && index < store.editHistory.length) {
      const historyItem = store.editHistory[index];
      
      // 선택한 히스토리 아이템의 결과 이미지를 현재 결과 이미지로 설정
      imageStore.update(imgStore => ({
        ...imgStore,
        resultImage: historyItem.resultImage,
        resultFeature: historyItem.feature?.id, resultOptions: historyItem.settings, resultImages: null,
        // 캔버스 데이터도 해당 시점으로 복원
        canvasData: historyItem.canvasData || null
      }));
      
      console.log(`편집 기록 ${index}번으로 이동, 이미지 복원됨`);
      
      return {
        ...store,
        currentEditIndex: index,
        selectedFeature: historyItem.feature,
        // 해당 편집 기능의 설정값도 복원
        ...(historyItem.settings ? { settings: historyItem.settings } : {})
      };
    }
    return store;
  });
}
